import React, { useEffect, useState } from "react";
import { PieChartCard } from "./PieChartCard";
import { getPromoterDetractors } from "../utils/feedbackDataUtils";

const FeedbackPieChart = ({ data, npsOverall }) => {
  const [feedbackData, setFeedbackData] = useState([]);

  const COLORS = npsOverall
    ? ["#FB9B0B", "#f9f939", "#fd6b3a"]
    : ["#00A6FB", "#006494", "#0582CA"];

  useEffect(() => {
    if (data) {
      const month = new Date().getMonth();
      const monthNPSData = data.filter((item) => {
        const created = new Date(item?.createdDate).getMonth();
        return month === created;
      });
      const response = npsOverall ? data : monthNPSData;
      const result = getPromoterDetractors(response);
      setFeedbackData(result);
    }
  }, [data]);

  return (
    <PieChartCard
      title={`NPS Category Distribution (${
        npsOverall ? "Overall" : "This Month"
      })`}
      data={feedbackData}
      colors={COLORS}
      innerRadius={70}
      outerRadius={100}
    />
  );
};

export default FeedbackPieChart;
